import React, { createContext, FC, useState, useEffect, useContext, useMemo, useCallback, useRef } from 'react';
import { HubConnectionBuilder, HttpTransportType, HubConnection } from '@microsoft/signalr';
import { useToasts } from '@brg/ui';
import { API, Endpoints } from '@brg/api';
import { getContextFromAppName, useFingerprintId, useProfile } from "@brg/auth";
import { useAuth } from "@brg/auth";
import useLocalization from '../hooks/useLocalization';
import { useDispatch, useSelector } from 'react-redux';
export var VotesContext = createContext({
    connection: undefined,
    connectionId: undefined,
    voteData: [],
});
var REACT_APP_API_CONNECTION_MODE = process.env.REACT_APP_API_CONNECTION_MODE;
var getUrl = function () {
    switch (REACT_APP_API_CONNECTION_MODE) {
        case 'production':
            return 'https://notifications.mediiia.ru';
        case 'staging':
            return 'https://notifications.burgstg.ru';
        default:
            return 'https://notifications.burgdev.ru';
    }
};
export var VotesProvider = function (_a) {
    var children = _a.children;
    var _b = useState(), currentConnection = _b[0], setCurrentConnection = _b[1];
    var _c = useState(), connectionId = _c[0], setConnectionId = _c[1];
    var _d = useState([]), voteData = _d[0], setVoteData = _d[1];
    var _e = useState([]), voteDataCount = _e[0], setVoteDataCount = _e[1];
    var _f = useState(false), needToStart = _f[0], setNeedToStart = _f[1];
    var fingerprintId = useFingerprintId();
    var _g = useLocalization(), t = _g.t, language = _g.language;
    var token = useAuth().token;
    var profile = useProfile();
    var dispatch = useDispatch();
    var appName = 'deziiign';
    var serviceId = 'deziiign';
    var clientId = 'superpuper';
    var voteEntityId = useSelector(function (store) { var _a; return ((_a = store.voteEntity) === null || _a === void 0 ? void 0 : _a.voteEntityId) || null; });
    var isEndVote = useSelector(function (store) { var _a; return ((_a = store.voteWinner) === null || _a === void 0 ? void 0 : _a.isThereWinner) || null; });
    var connectionRef = useRef();
    // voteEntityId = 'id голосовлки' entityType= 'poll'
    useEffect(function () {
        if (!isEndVote) {
            var connection_1 = new HubConnectionBuilder()
                .withUrl("".concat(getUrl(), "/WebSocketProvider?entityId=").concat(voteEntityId, "&entityType=poll"), {
                accessTokenFactory: function () { return token; },
                transport: HttpTransportType.WebSockets
            })
                .withAutomaticReconnect()
                .build();
            connectionRef.current = connection_1;
            if (profile || fingerprintId) {
                connection_1
                    .start()
                    .then(function () {
                    connection_1
                        .invoke('GetConnectionId', serviceId, clientId, (profile === null || profile === void 0 ? void 0 : profile.accountId) ? profile === null || profile === void 0 ? void 0 : profile.accountId : fingerprintId)
                        .then(function (connectionId) {
                        setConnectionId(connectionId);
                    });
                    // onStart();
                })
                    .catch(console.error);
                setCurrentConnection(connection_1);
                connection_1.on('Entity', function (data) {
                    var parse = JSON.parse(data);
                    var newData = JSON.parse(parse.data);
                    var newStage = newData;
                    if ((newStage === null || newStage === void 0 ? void 0 : newStage.Action) === "stage") {
                        setVoteData(newStage === null || newStage === void 0 ? void 0 : newStage.Poll);
                        return;
                    }
                    if ((newStage === null || newStage === void 0 ? void 0 : newStage.Action) === "update") {
                        setVoteDataCount(newStage === null || newStage === void 0 ? void 0 : newStage.Poll);
                        return;
                    }
                    if ((newStage === null || newStage === void 0 ? void 0 : newStage.Action) === "start") {
                        setNeedToStart(true);
                        return;
                    }
                });
            }
            return function () {
                void connection_1.stop();
            };
        }
    }, [profile, language, voteEntityId, isEndVote, fingerprintId]);
    if (voteEntityId === '') {
        return null;
    }
    return (React.createElement(VotesContext.Provider, { value: {
            connection: currentConnection,
            connectionId: connectionId,
            voteData: voteData,
            voteDataCount: voteDataCount,
            needToStart: needToStart,
            setNeedToStart: setNeedToStart
        } }, children));
};
export function useVotesContext() {
    return useContext(VotesContext);
}
//# sourceMappingURL=VotesContext.js.mapimport React, { createContext, FC, useState, useEffect, useContext, useMemo, useCallback, useRef } from 'react';
import { HubConnectionBuilder, HttpTransportType, HubConnection } from '@microsoft/signalr';
import { useToasts } from '@brg/ui';
import { API, Endpoints } from '@brg/api';
import { getContextFromAppName, useFingerprintId, useProfile } from "@brg/auth";
import { useAuth } from "@brg/auth";
import useLocalization from '../hooks/useLocalization';
import { useDispatch, useSelector } from 'react-redux';
export var VotesContext = createContext({
    connection: undefined,
    connectionId: undefined,
    voteData: [],
});
var REACT_APP_API_CONNECTION_MODE = process.env.REACT_APP_API_CONNECTION_MODE;
var getUrl = function () {
    switch (REACT_APP_API_CONNECTION_MODE) {
        case 'production':
            return 'https://notifications.mediiia.ru';
        case 'staging':
            return 'https://notifications.burgstg.ru';
        default:
            return 'https://notifications.burgdev.ru';
    }
};
export var VotesProvider = function (_a) {
    var children = _a.children;
    var _b = useState(), currentConnection = _b[0], setCurrentConnection = _b[1];
    var _c = useState(), connectionId = _c[0], setConnectionId = _c[1];
    var _d = useState([]), voteData = _d[0], setVoteData = _d[1];
    var _e = useState([]), voteDataCount = _e[0], setVoteDataCount = _e[1];
    var _f = useState(false), needToStart = _f[0], setNeedToStart = _f[1];
    var fingerprintId = useFingerprintId();
    var _g = useLocalization(), t = _g.t, language = _g.language;
    var token = useAuth().token;
    var profile = useProfile();
    var dispatch = useDispatch();
    var appName = 'deziiign';
    var serviceId = 'deziiign';
    var clientId = 'superpuper';
    var voteEntityId = useSelector(function (store) { var _a; return ((_a = store.voteEntity) === null || _a === void 0 ? void 0 : _a.voteEntityId) || null; });
    var isEndVote = useSelector(function (store) { var _a; return ((_a = store.voteWinner) === null || _a === void 0 ? void 0 : _a.isThereWinner) || null; });
    var connectionRef = useRef();
    // voteEntityId = 'id голосовлки' entityType= 'poll'
    useEffect(function () {
        if (!isEndVote) {
            var connection_1 = new HubConnectionBuilder()
                .withUrl("".concat(getUrl(), "/WebSocketProvider?entityId=").concat(voteEntityId, "&entityType=poll"), {
                accessTokenFactory: function () { return token; },
                transport: HttpTransportType.WebSockets
            })
                .withAutomaticReconnect()
                .build();
            connectionRef.current = connection_1;
            if (profile || fingerprintId) {
                connection_1
                    .start()
                    .then(function () {
                    connection_1
                        .invoke('GetConnectionId', serviceId, clientId, (profile === null || profile === void 0 ? void 0 : profile.accountId) ? profile === null || profile === void 0 ? void 0 : profile.accountId : fingerprintId)
                        .then(function (connectionId) {
                        setConnectionId(connectionId);
                    });
                    // onStart();
                })
                    .catch(console.error);
                setCurrentConnection(connection_1);
                connection_1.on('Entity', function (data) {
                    var parse = JSON.parse(data);
                    var newData = JSON.parse(parse.data);
                    var newStage = newData;
                    if ((newStage === null || newStage === void 0 ? void 0 : newStage.Action) === "stage") {
                        setVoteData(newStage === null || newStage === void 0 ? void 0 : newStage.Poll);
                        return;
                    }
                    if ((newStage === null || newStage === void 0 ? void 0 : newStage.Action) === "update") {
                        setVoteDataCount(newStage === null || newStage === void 0 ? void 0 : newStage.Poll);
                        return;
                    }
                    if ((newStage === null || newStage === void 0 ? void 0 : newStage.Action) === "start") {
                        setNeedToStart(true);
                        return;
                    }
                });
            }
            return function () {
                void connection_1.stop();
            };
        }
    }, [profile, language, voteEntityId, isEndVote, fingerprintId]);
    if (voteEntityId === '') {
        return null;
    }
    return (React.createElement(VotesContext.Provider, { value: {
            connection: currentConnection,
            connectionId: connectionId,
            voteData: voteData,
            voteDataCount: voteDataCount,
            needToStart: needToStart,
            setNeedToStart: setNeedToStart
        } }, children));
};
export function useVotesContext() {
    return useContext(VotesContext);
}
//# sourceMappingURL=VotesContext.js.map